import Footer from "@Components/Layout/Footer";
import Login from "@Components/Pages/Login";

const LoginPage = () => {
  return (
    <>
      <Login />
      <Footer />
    </>
  );
};
export default LoginPage;
LoginPage.displayName = "login";
